var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-left":"0px","padding-right":"0px","padding-top":"20px","margin-top":"50px","margin-left":"0px","margin-right":"0px","height":"10px"}},[_c('v-icon',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("fas fa-arrow-circle-left")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }